exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-sticky-msg[data-v-afeb8dc4]{position:-webkit-sticky!important;position:sticky!important;top:167px!important;z-index:97}", ""]);

// exports
